export const defaults = {
  PRIVACY_POLICY_URL: 'https://www.tvsd.ai/en/privacy-policy',
  TERMS_OF_USE_URL: 'https://www.tvsd.ai/en/terms-of-use',
  COOKIE_POLICY_URL: 'https://www.tvsd.ai/en/cookie-policy',
};
